import React, { createContext, useState } from 'react';

export const FacilityFiltersStateContext = createContext();

const INITIAL_STATE = {
  filterObject: {},
  sortBy: ''
};

const FacilityFiltersContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <FacilityFiltersStateContext.Provider value={stateHook}>
      {children}
    </FacilityFiltersStateContext.Provider>
  );
};

export default FacilityFiltersContextProvider;